import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { FormWizardCustomFieldAdapter } from '@shared/components/form/form-wizard/form-wizard-field-registry.service';
import { FormFieldConfig } from '@shared/components/form/form-wizard/models/form-wizard.models';
import { AmenitiesSelectorComponent } from '@shared/components/form/investment-description-enhanced/amenities-selector.component';

@Component({
  selector: 'app-investment-amenities-selector-form-field',
  standalone: true,
  imports: [ReactiveFormsModule, AmenitiesSelectorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-amenities-selector
      [formControl]="control"
      [disabled]="field.disabled || false"
    />
  `,
})
export class InvestmentAmenitiesSelectorFormFieldComponent
  implements FormWizardCustomFieldAdapter {
  @Input({ required: true }) field!: FormFieldConfig;
  @Input({ required: true }) form!: FormGroup;

  get control(): FormControl {
    return this.form.get(this.field.key) as FormControl;
  }
}
